/* eslint-disable react-hooks/exhaustive-deps */
import { Button, DatePicker, Form, Input, Space } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DateIcon from "../../../assets/icons/DateIcon";
import { dateFormat, dbDateFormat } from "../../../constants/constants";
import {
  useAddHolidayMutation,
  useGetHolidayDetailsQuery,
  useUpdateHolidayMutation,
} from "../../../features/holiday/holidayApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { formatDate } from "../../../lib/time";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";
import SuccessModal from "../../Report/SuccessModal";
import CustomModal from "../../ui/CustomModal";
import Loader from "../../ui/Loader";

export default function ManageHoliday({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps<string>) {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const {
    isLoading: isHolidayLoading,
    isError: isHolidayDetailsError,
    error: holidayDetailsError,
    data: holidayDetails,
  } = useGetHolidayDetailsQuery(data || "", {
    skip: !data && type !== "UPDATE",
  });
  const [
    addHoliday,
    { isLoading, isError, isSuccess, error, data: createdHolliday },
  ] = useAddHolidayMutation();
  // Define a type for the expected response data
  type HolidayResponse = {
    data?: {
      status?: string;
      [key: string]: any;
    };
    [key: string]: any;
  };

  const [
    updateHoliday,
    {
      isLoading: isUpdateLoading,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
      error: updateError,
      data: updatedHoliday,
    },
  ] = useUpdateHolidayMutation<HolidayResponse>();
  // error toast message
  useError(isError, error, "Holiday added fail");
  useError(isUpdateError, updateError, "Holiday updated fail");
  useError(isHolidayDetailsError, holidayDetailsError, "Get holiday fail");
  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  const onFinish = (values: any) => {
    const { date, ...rest } = values;

    const newData = {
      ...rest,
      start_date: formatDate(date?.[0]?.format(), dbDateFormat),
      end_date: formatDate(date?.[1]?.format(), dbDateFormat),
    };

    if (type === "UPDATE" && data) {
      return updateHoliday({ body: newData, id: data });
    }

    return addHoliday(newData);
  };

  useEffect(() => {
    if (Object.keys(holidayDetails?.data || {}) && type === "UPDATE") {
      const details = holidayDetails?.data;

      form.setFieldsValue({
        title: details?.title,
        date: [dayjs(details?.start_date), dayjs(details?.end_date)],
      });
    }
  }, [form, holidayDetails?.data, type]);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Holiday added successfully");
      handleOpen({ type: "SUCCESS" });
      // if (createdHolliday?.data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
    }
    if (isUpdateSuccess) {
      toast("success", "Holiday updated successfully");
      handleOpen({ type: "SUCCESS" });
      // if (updatedHoliday?.data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
    }
  }, [isSuccess, isUpdateSuccess]);

  return (
    <>
      <CustomModal
        title={type === "UPDATE" ? "Update Holiday" : "Add New Holiday"}
        {...rest}
        handleClose={handleClose}
        width={460}
        footer={null}
      >
        {childOpen?.type === "SUCCESS" && (
          <SuccessModal
            type="queue"
            open={childOpen?.open}
            handleClose={childClose}
          />
        )}
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          {isHolidayLoading ? (
            <Loader />
          ) : (
            <>
              <Form.Item
                name="date"
                label="Date"
                className="mb-4 w-full"
                rules={[
                  {
                    required: true,
                    message: "Please enter date",
                  },
                ]}
              >
                <DatePicker.RangePicker
                  className="w-full"
                  format={dateFormat}
                  suffixIcon={<DateIcon />}
                  // disabledDate={disablePastDates}
                  // disabledDate={type === "UPDATE" ? undefined : disablePastDates}
                />
              </Form.Item>
              <Form.Item
                name="title"
                label="Holiday Name"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter holiday name",
                  },
                ]}
              >
                <Input size="large" placeholder="Ex: Eid al-Adha" />
              </Form.Item>
            </>
          )}

          <Space className="w-full mt-2" size={12}>
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
              disabled={isLoading || isUpdateLoading}
            >
              Cancel
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              loading={isLoading || isUpdateLoading}
            >
              {type === "UPDATE" ? "Update" : "Save"}
            </Button>
          </Space>
        </Form>
      </CustomModal>
    </>
  );
}
